module.exports = __webpack_public_path__ + "static/media/eb-about-us.bde1ff41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eb-about-us.svg
// module id = 5752
// module chunks = 11